import type { VehicleModelDetailsEntity } from '~/domain/Insurance/vehicleModelDetailsEntity';
import apiAssegurouAuto from '../../services/apiAssegurouAuto';
import type { VehicleModelDetailsResponseDTO } from '~/dto/Insurance/vehicleModelDetailsDTO';
import { vehicleModelDetailsResponseMapper } from '~/mappers/Insurance/vehicleModelDetailsResponseMapper';

export async function getVehicleModelDetailsUseCase(
  manufacturerId: string,
  modelId: string,
  modelYearId: string
): Promise<VehicleModelDetailsEntity> {
  try {
    const response = await apiAssegurouAuto.get<VehicleModelDetailsResponseDTO>(
      `/auto/getDadosModelo/1/${manufacturerId}/${modelYearId}/${modelId}`
    );
    return vehicleModelDetailsResponseMapper(response.data);
  } catch (error) {
    return {
      success: false,
      fipeCode: null,
      fipeValue: null,
      modelDescription: null,
      brandDescription: null,
    };
  }
}
